<script setup lang="ts">
import SimpleBar from "simplebar";
import { computed, ref, watchEffect } from "vue";
import { locale } from "../../locale";
import TextMessage from "./message_companents/TextMessage.vue";
import DateSeparator from "./DateSeparator.vue";
import { historyMessagesList } from "../../states/chatHistoryState";
import FileMessageHistory from "./historyComponents/FileMessageHistory.vue";
import { setScrollChat } from "../../states/scrollHistoryChatState";
import HistoryScrollToBottomBtn from "./HistoryScrollToBottomBtn.vue";

const scroll = ref<HTMLElement | null>(null);

watchEffect(() => {
  if (scroll.value) {
    const smp = new SimpleBar(scroll.value, { autoHide: false });
    setScrollChat(smp);
  }
});
function getMessageKey(m: (typeof historyMessagesList.value)[number]) {
  if ("id" in m) return m.id;
  else return m.text;
}
const byDate = computed(() => {
  const res = [] as (typeof historyMessagesList.value)[];
  let last: typeof historyMessagesList.value = [];
  for (const message of historyMessagesList.value) {
    if (message.type === "DateMark") {
      last = [message];
      res.push(last);
    } else {
      last.push(message);
    }
  }
  return res;
});
</script>
<template>
  <div ref="messageArea" class="chat-messages-wrapper">
    <HistoryScrollToBottomBtn />
    <div v-if="historyMessagesList.length" ref="scroll" class="scroll-chat">
      <div class="chat-messages-area">
        <div class="day" v-for="(day, id) in byDate" :key="id">
          <div class="one-message-wrapper" :class="{
            'date-sticky': message.type === 'DateMark',
          }" v-for="message in day" :key="getMessageKey(message)">
            <div class="one-message-wrapper">
              <TextMessage v-if="message.type === 'Text'" :message="message" />
              <FileMessageHistory v-else-if="message.type === 'File'" :message="message" />
              <DateSeparator v-else-if="message.type === 'DateMark'" :text="message.text" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="placeholder-chat">
      <div class="text">
        {{ locale.chat.emptyHistory }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.one-message-wrapper {
  width: 100%;
}

.date-sticky {
  position: sticky;
  z-index: 2000;
  top: 8px;
}

.chat-messages-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("@images/chat_bg3.png");
  background-repeat: repeat;
}

.scroll-chat {
  width: 100%;
  max-height: 100%;
  height: 100%;
}

.chat-messages-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
}

.day {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
}

.placeholder-chat {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-chat .text {
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.7px;
  text-align: center;
  color: rgba(164, 164, 164, 1);
}
</style>
<style>
.chat-messages-wrapper .simplebar-vertical .simplebar-scrollbar::before {
  background-color: #676666;
  width: 4px;
}
</style>
